import DeviceManager from '../utils/device-manager';
import $ from "jquery";

class HomeSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
            direction: 'horizontal',
            loop: true,
            freeMode: false,
            slidesPerView: 1,
            slideToClickedSlide: true,
            effect: "fade",
            centeredSlides: true,
            fadeEffect: { crossFade: true },
            autoplay: {
                delay: 7000,
                disableOnInteraction: false
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
		};

		if (this.$el.length) {
			this._init();
		}
	}

    _init() {
        this.$slides = this.$el.find('.homepage-slider__slide');
        this.slidesCount = this.$slides.length;

        // console.log('Nombre de slides HEADER: ' + this.slidesCount);

        if(this.slidesCount > 0) {
            this._createSlider();
        }
    }

    _createSlider() {
        new Swiper(this.$el[0], this.options);
    }

    _destroy() {
        if(this.slider) {
            this.slider.destroy(true,true);
            this.slider = null;
        }
    }

}

export default HomeSlider;
